import { Invite } from '../models/commonModels';
import fetch from './fetch';

export default (inviteId: string): Promise<Invite> =>
    fetch<Invite>(`/invites/${inviteId}`, {
        method: 'GET',
    });
